module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "instock-tab"
  }, [(_vm.specArray.length > 1) ? _c('h1', {
    staticClass: "theme"
  }, [_c('i'), _c('span', [_vm._v("产品规格")])]) : _vm._e(), _vm._v(" "), (_vm.specArray.length > 1) ? _c('ul', {
    staticClass: "productCon listCPGG"
  }, _vm._l((_vm.specArray), function(spec, index) {
    return _c('li', {
      class: {
        active: index === _vm.tabNum
      },
      on: {
        "click": function($event) {
          _vm.tabLi(spec.id, index)
        }
      }
    }, [_vm._v("\n        " + _vm._s(spec.specification) + "\n      ")])
  })) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "border": "",
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "入库日期",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.instockTime) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "入库类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.typeName) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "入库单据"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          on: {
            "click": function($event) {
              _vm.openDetail(scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(scope.row.sheetNo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "入库仓库"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.warehouseName) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "入库数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.productNum) + "\n        ")]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total > 0) ? _c('div', {
    staticClass: "pagination-wrapper clearfix"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "page-sizes": [10, 20, 30, 40],
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "theme"
  }, [_c('i'), _c('span', [_vm._v("入库单")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-754a6498","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/product/instock-tab.vue
// module id = 1302
// module chunks = 82